import cx from 'classnames';
import { P, match } from 'ts-pattern';

import { Input } from 'lib/common/components/Input';

import { useAIContext } from '../../Context';
import { IQActionsMenu } from '../IQActionsMenu';
import IQCritique from '../IQCritique';
import { IQRefineModes } from '../IQEvaluateMenu';
import IQCursorOrb from '../common/IQCursorOrb';
import IQRequestError from '../common/IQRequestError';
import { IQDisplayMode, TIQDisplayMode } from '../constants/IQDisplayMode';
import { IQResponseState } from '../constants/IQResponseState';
import IQMenuContainerHeader from './components/IQMenuContainerHeader';

import styles from './iq-menu-container.module.scss';

const SecondaryMenuContent = ({
  displayMode,
  showAcceptForRewrites,
}: {
  displayMode: TIQDisplayMode;
  showAcceptForRewrites?: boolean;
}) => {
  const {
    state: { selectedAction, selectedMode, requestState, streamingState },
  } = useAIContext();

  const hasStreamingContent = Object.values(streamingState).some(Boolean);
  const Critique = <IQCritique displayMode={displayMode} showAcceptForRewrites={showAcceptForRewrites} />;

  return match({ requestState, selectedAction, selectedMode })
    .with({ requestState: IQResponseState.RETHINKING }, () => Critique)
    .with({ requestState: IQResponseState.THINKING }, () => hasStreamingContent ? Critique : <IQCursorOrb speed="SLOW" />)
    .with({ requestState: IQResponseState.ERROR }, () => <IQRequestError />)
    .with({ selectedAction: P.union('FEEDBACK', 'REWRITE'), selectedMode: P.nullish }, () => (
      <IQRefineModes displayMode={displayMode} showAcceptForRewrites={showAcceptForRewrites} />
    ))
    .otherwise(() => Critique);
};

export default function IQMenuContainer({
  displayMode,
  showAcceptForRewrites = true,
}: {
  displayMode: TIQDisplayMode;
  showAcceptForRewrites?: boolean;
}) {
  const {
    state: { selectedAction, iqInput },
    actions: { setIQInput },
  } = useAIContext();

  return (
    <div className={cx(styles['iq-menu-container'], {
      [styles['iq-menu-container--comfortable']]: displayMode === IQDisplayMode.COMFORTABLE,
    })}>
      {displayMode !== IQDisplayMode.STAND_ALONE && <IQMenuContainerHeader displayMode={displayMode} />}

      <div className={cx(styles['iq-menu-container__content'])}>
        <div
          className={cx(styles['iq-menu-container__content__actions'], {
            [styles['iq-menu-container__content__actions--stand-alone']]: displayMode === IQDisplayMode.STAND_ALONE,
            [styles['iq-menu-container__content__actions--hidden']]: selectedAction,
          })}
        >
          <div
            className={cx({
              [styles['iq-menu-container__content__actions--stand-alone__input-container']]:
                displayMode === IQDisplayMode.STAND_ALONE,
            })}
          >
            {displayMode == IQDisplayMode.STAND_ALONE && (
              <div className={styles['iq-menu-container__content__actions--stand-alone__input']}>
                <Input
                  noBorder
                  noPadding
                  multiline
                  placeholder="Start writing here..."
                  onChange={(e) => setIQInput(e.target.value)}
                  value={iqInput || ''}
                />
              </div>
            )}
            <IQActionsMenu displayMode={displayMode} />
          </div>
        </div>
        <div
          className={cx(styles['iq-menu-container__content__evaluate'], {
            [styles['iq-menu-container__content__evaluate--visible']]: selectedAction,
          })}
        >
          <SecondaryMenuContent displayMode={displayMode} showAcceptForRewrites={showAcceptForRewrites} />
        </div>
      </div>
    </div>
  );
}
